export default __webpack_public_path__ + "static/media/errormsg.9c42be30.svg";